var React = require('react');

function ListViewOneColumn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"transparent","d":"M47 47H1V1h46Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M2 2v44h44V2zM0 0h48v48H0Z","key":1}),React.createElement("path",{"fill":"none","d":"M14 14h21v21H14Z","key":2}),React.createElement("path",{"fill":"currentColor","d":"M16 16v17h17V16zm-2-2h21v21H14Z","key":3})]);
}

ListViewOneColumn.defaultProps = {"width":"48","height":"48","data-name":"Layer 1","viewBox":"0 0 48 48"};

module.exports = ListViewOneColumn;

ListViewOneColumn.default = ListViewOneColumn;
